import { useContext } from 'react';
import AuthContext from '@cpg-its/ads.auth.auth-context';
import { ProfileKey } from '../constants/constant-strings';
import { AuthToken } from '../../../global/models/authenticated-model';


export const useDeserializedToken = () => {
	try {		
		const { decodedToken } = useContext(AuthContext) as any;
		if (!decodedToken || !decodedToken[ProfileKey]) {
			return null;
		}
		return JSON.parse(decodedToken[ProfileKey]) as AuthToken;
	} catch {
		return null;
	}
};